import { apiGet } from 'api';
import { GetConsulteeTeamsResponse } from '../../types';

export const getConsulteeTeams = (): Promise<GetConsulteeTeamsResponse> =>
  apiGet<GetConsulteeTeamsResponse>('consultee/teams');
